import React from "react";

function About() {
    return (
        <div className="p-8 max-w-3xl mx-auto">
            <h1 className="text-3xl font-bold mb-4">Über uns</h1>
            <p>
                Willkommen bei Auto-Service Groß GmbH. Wir sind Ihr kompetenter Ansprechpartner für alle Fragen rund ums Automobil in Bad Bellingen. Wir bieten Ihnen vom Neuwagen bis zum Service alles aus einer Hand.
            </p>
            <h2 className="text-xl font-semibold mt-6">Willkommen beim Autohaus Groß</h2>
            <p className="mt-4">
                Seither bieten wir Ihnen den kompletten Service rund um ihr Fahrzeug. Ob Sie an Ihrem Fahrzeug eine Inspektion oder Reparatur wünschen, oder ob Sie unseren Räder-, Reifen-, Unfall-, oder TÜV-Abnahme-Service in Anspruch nehmen möchten - unser geschultes, engagiertes Fachpersonal berät Sie gerne. Mit unserer modern ausgestatteten Werkstatt und unserem kompetenten Service sind wir Ihre Fachwerkstatt aller Fabrikate - und das zu einem fairen Preis.
            </p>
            <p className="mt-4">
                Gerne beraten wir Sie auch beim Kauf eines neuen Fahrzeuges, wir bieten Ihnen auf unserer Ausstellungsfläche und in unserer Ausstellungshalle eine kleine aber feine Auswahl an Neu- und Gebrauchtwagen. Ebenso informieren wir Sie gerne unverbindlich über Finanzierung und Leasing.
            </p>
            <p className="mt-4">
                Wir sind als Familienbetrieb flexibel, zuverlässig und kundennah - da lohnt sich jeder Weg !!
            </p>
        </div>
    );
}

export default About;
